/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-10-24",
    versionChannel: "nightly",
    buildDate: "2024-10-24T00:06:21.908Z",
    commitHash: "ce859c36d3935e270df822e5765ad40d76178220",
};
